"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCustomSelect;

var _react = require("react");

var _downshift = require("downshift");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function useCustomSelect(isMultiple, isSearchable, props) {
  var items = props.items,
      selectedItem = props.selectedItem,
      selectedItems = props.selectedItems,
      onChange = props.onChange;
  var searchInputRef = (0, _react.useRef)(null);
  var focusingSearchRef = (0, _react.useRef)(false);

  var _useMultipleSelection = (0, _downshift.useMultipleSelection)({
    selectedItems: selectedItems || []
  }),
      getDropdownProps = _useMultipleSelection.getDropdownProps;

  function toggleSelectedItem(selectedItem) {
    if (selectedItem) {
      if (_lodash.default.find(selectedItems, {
        value: selectedItem.value
      })) {
        onChange(_lodash.default.reject(selectedItems, {
          value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value
        }));
      } else {
        onChange([].concat(_toConsumableArray(selectedItems), [selectedItem]));
      }
    }
  }

  function multiStateReducer(state, _ref) {
    var changes = _ref.changes,
        type = _ref.type;

    switch (type) {
      case _downshift.useSelect.stateChangeTypes.MenuKeyDownEnter:
      case _downshift.useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
      case _downshift.useSelect.stateChangeTypes.ItemClick:
        toggleSelectedItem(items[state.highlightedIndex]);
        return _objectSpread(_objectSpread({}, changes), {}, {
          isOpen: true,
          // keep the menu open after selection.
          highlightedIndex: state.highlightedIndex
        });

      case _downshift.useSelect.stateChangeTypes.MenuBlur:
        if (focusingSearchRef.current) {
          focusingSearchRef.current = false;
          return _objectSpread(_objectSpread({}, changes), {}, {
            isOpen: true
          });
        } else {
          return changes;
        }

      default:
        return changes;
    }
  }

  function singleStateReducer(state, _ref2) {
    var _items$changes$highli;

    var changes = _ref2.changes,
        type = _ref2.type; // We need to jump over the spacer when using arrow keys

    var isSpacer = ((_items$changes$highli = items[changes.highlightedIndex]) === null || _items$changes$highli === void 0 ? void 0 : _items$changes$highli.value) === '|';

    switch (type) {
      case _downshift.useSelect.stateChangeTypes.MenuKeyDownArrowDown:
      case _downshift.useSelect.stateChangeTypes.ToggleButtonKeyDownArrowDown:
        return isSpacer ? _objectSpread(_objectSpread({}, changes), {}, {
          highlightedIndex: changes.highlightedIndex + 1
        }) : changes;

      case _downshift.useSelect.stateChangeTypes.MenuKeyDownArrowUp:
      case _downshift.useSelect.stateChangeTypes.ToggleButtonKeyDownArrowUp:
        return isSpacer ? _objectSpread(_objectSpread({}, changes), {}, {
          highlightedIndex: changes.highlightedIndex - 1
        }) : changes;

      case _downshift.useSelect.stateChangeTypes.MenuBlur:
        if (focusingSearchRef.current) {
          focusingSearchRef.current = false;
          return _objectSpread(_objectSpread({}, changes), {}, {
            isOpen: true
          });
        } else {
          return changes;
        }

      default:
        return changes;
    }
  }

  var selectHookProps = {
    items: items,
    itemToString: function itemToString(item) {
      return (item === null || item === void 0 ? void 0 : item.label) || '';
    },
    onIsOpenChange: function onIsOpenChange(changes) {
      if (changes.isOpen && isSearchable && searchInputRef.current) {
        focusingSearchRef.current = true;
        setTimeout(function () {
          searchInputRef.current.focus();
        }, 50);
      }
    }
  };

  if (isMultiple) {
    selectHookProps.stateReducer = multiStateReducer;
  } else {
    selectHookProps.selectedItem = selectedItem;

    selectHookProps.onSelectedItemChange = function (_ref3) {
      var selectedItem = _ref3.selectedItem;
      return onChange(selectedItem);
    };

    selectHookProps.stateReducer = singleStateReducer;
  }

  var _useSelect = (0, _downshift.useSelect)(selectHookProps),
      isOpen = _useSelect.isOpen,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getMenuProps = _useSelect.getMenuProps,
      highlightedIndex = _useSelect.highlightedIndex,
      getItemProps = _useSelect.getItemProps;

  return {
    // Select props
    isOpen: isOpen,
    getToggleButtonProps: getToggleButtonProps,
    getMenuProps: getMenuProps,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    // isMultiple props
    getDropdownProps: getDropdownProps,
    // other props
    searchInputRef: searchInputRef
  };
}